import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addFile } from "./defineSlice";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useRef } from "react";

import {
	setState,
 } from "./defineSlice";
 
export default function FileUpload() {
	const autherization = localStorage.getItem("data");
	const State = useSelector((store) => store.define);
	const { files } = State;
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const inputRef = useRef(null);
	const dispatch = useDispatch();

	function handleInputClick() {
		inputRef.current.click();
	}

	function uploadFile(event) {
		const file = event.target.files[0];
		const obj = event.target.files[0];
		console.log(file);
		let idx = files.findIndex((f) => f.name === file.name);
		if(idx > -1) {
			showMessage("File already attached");
			return;
		}
		dispatch(addFile(obj));
	}

	useEffect(()=>{
		resetFileInput();
	},[files]);

	const showMessage = (message) => {
		dispatch(setState("isFailed_Info", message));
		dispatch(setState("isFailed", true));
	 };

	const resetFileInput = () => { inputRef.current.value = ''; };
	return (
		<Box sx={{mt:2}}>
			{/* <Typography className="compHeading"
                  sx={{fontWeight: "bold", color: "blue.main", width: "100%" }}
               >
                   <AttachmentIcon sx={{ color: "blue.main", transform: "translate(0px, 6px)", mr: 1,}} />
                  Attach File
               </Typography> */}
			<input hidden type="file" ref={inputRef} onChange={uploadFile} />

			<Button
				sx={{
					bgcolor: "darkred.light",
					color: "white.main",
					fontWeight: "700",
					ml: "calc(100% - 140px);",
					textTransform: "none",
					"&:hover": {
						bgcolor: "darkred.main",

					},
				}}
				disabled={!isRestrictedAccess}
				startIcon={<AttachmentIcon />}

				onClick={handleInputClick}
			>
				Attach File
			</Button>
		</Box>
	);
}
